// extracted by mini-css-extract-plugin
export default {"layout":"layout___L7uM1","authorImage":"authorImage___N7bRS","authorInfo":"authorInfo___xfp3p","description":"description___g_ZL4"};